import apiUser from '@src/api/user';

export default {
  state: {
    recentDocuments: [],
    recentDocumentsTotal: 0,
    favoriteDocuments: [],
    favoriteDocumentsTotal: 0,
    favoriteDocumentsWithFolders: [],
    classifiersList: [],

    watchlistDocuments: [],
    watchlistDocumentsTotal: 0,
    watchlistDocumentEvents: [],
    watchlistUnreadDocumentsTotal: 0,
    isLoading: false
  },

  getters: {
    recentDocuments: state =>
      state.recentDocuments.map(i => JSON.parse(JSON.stringify(i))),
    recentDocumentsTotal: state => state.recentDocumentsTotal,
    favoriteDocuments: state =>
      state.favoriteDocuments.map(i => JSON.parse(JSON.stringify(i))),
    favoriteDocumentsTotal: state => state.favoriteDocumentsTotal,
    favoriteDocumentsWithFolders: state =>
      state.favoriteDocumentsWithFolders.map(i => JSON.parse(JSON.stringify(i))),
    watchlistDocuments: state =>
      state.watchlistDocuments.map(i => JSON.parse(JSON.stringify(i))),
    watchlistDocumentsTotal: state => state.watchlistDocumentsTotal,
    watchlistDocumentEvents: state =>
      state.watchlistDocumentEvents.map(i => JSON.parse(JSON.stringify(i))),
    watchlistUnreadDocumentsTotal: state => state.watchlistUnreadDocumentsTotal,
    showLoader: state => state.isLoading
  },

  mutations: {
    SET_RECENT_DOCUMENTS(state, arr) {
      state.recentDocuments = arr;
    },
    SET_RECENT_DOCUMENTS_COUNT(state, num) {
      state.recentDocumentsTotal = num;
    },
    SET_FAVORITE_DOCUMENTS(state, arr) {
      state.favoriteDocuments = arr;
    },
    SET_FAVORITE_DOCUMENTS_COUNT(state, num) {
      state.favoriteDocumentsTotal = num;
    },
    SET_FAVORITE_DOCUMENTS_WITH_FOLDERS(state, arr) {
      state.favoriteDocumentsWithFolders = arr;
    },
    SET_WATCHLIST_DOCUMENTS(state, arr) {
      state.watchlistDocuments = arr;
    },
    SET_WATCHLIST_DOCUMENTS_COUNT(state, num) {
      state.watchlistDocumentsTotal = num;
    },
    SET_WATCHLIST_DOCUMENT_EVENTS(state, arr) {
      state.watchlistDocumentEvents = arr;
    },
    SET_UNREAD_WATCHLIST_DOCUMENTS_COUNT(state, num) {
      state.watchlistUnreadDocumentsTotal = num;
    },
    SET_LOADING_STATE(state, status) {
      state.isLoading = status;
    }
  },

  actions: {
    // ----------------------- ПРОСМОТРЕННЫЕ ДОКУМЕНТЫ -------------------------------------
    // obj: {period: <>, itemsLimit: <number>, itemsOffset: <number>}
    async getRecentDocuments({ commit }, obj) {
      commit('SET_LOADING_STATE', true)
      try {
        const res = await apiUser.getRecentDocuments(
          obj.period,
          obj.itemsLimit,
          obj.itemsOffset
        );

        commit('SET_RECENT_DOCUMENTS', res.items);
        commit('SET_RECENT_DOCUMENTS_COUNT', res.total);
      } catch (err) {
        console.error(
          'Error on get recent documents: ',
          err.message ? err.message : err
        );
      } finally {      
        commit('SET_LOADING_STATE', false)
      }
    },

    // ----------------------- ИЗБРАННЫЕ ДОКУМЕНТЫ -------------------------------------
    // obj: {section: <>, itemsLimit: <number>, itemsOffset: <number>}
    async getFavoriteDocuments({ commit }, obj) {
      commit('SET_LOADING_STATE', true)
      try {
        const res = await apiUser.getFavoriteDocuments(
          obj.section,
          obj.itemsLimit,
          obj.itemsOffset
        );

        commit('SET_FAVORITE_DOCUMENTS', res.items);
        commit('SET_FAVORITE_DOCUMENTS_COUNT', res.total);
      } catch (err) {
        console.error(
          'Error on get favorite documents: ',
          err.message ? err.message : err
        );
      } finally {        
        commit('SET_LOADING_STATE', false)
      }
    },
    
    // obj: {section: <>}
    async getFavoriteDocumentsWithFolders({ commit }, obj) {
      commit('SET_LOADING_STATE', true)
      try {
        const res = await apiUser.getFavoriteDocumentsWithFolders(obj.section);
        commit('SET_FAVORITE_DOCUMENTS_WITH_FOLDERS', res);
      } catch (err) {
        console.log('Error when get favorite documents with folders: ', err);
      } finally {        
        commit('SET_LOADING_STATE', false)
      }
    },

    // obj: {documentId: <string>, favoriteId: <string>,}
    async removeDocumentFromFavorites({ dispatch, commit }, obj) {
      try {
        await apiUser.setDocumentIsFavorite(
          obj.documentId,
          false,
          obj.favoriteId
        );
        commit('TOGGLE_ITEM_AS_FAVORITE', {documentId: obj.documentId, isFavorite: false});

        dispatch('updateCurrentDocumentInfoProperty', {
          name: 'isFavorite',
          value: false
        });
      } catch (err) {
        console.error(
          'Error on remove document from favorites: ',
          err.message ? err.message : err
        );
      }
    },

    // ----------------------- ДОКУМЕНТЫ НА КОНТРОЛЕ -------------------------------------
    updateUnreadCount({ state, commit }, delta) {
      commit('SET_UNREAD_WATCHLIST_DOCUMENTS_COUNT', state.watchlistUnreadDocumentsTotal + delta);
    },
    // obj: {eventId: <>, obj.periodId: <>, limit: <number>, offset: <number>}
    async getWatchlistDocuments({ commit }, obj) {
      commit('SET_LOADING_STATE', true)
      try {
        const res = await apiUser.getWatchlistDocuments(obj.eventId, obj.periodId, obj.limit, obj.offset)
        
        commit('SET_WATCHLIST_DOCUMENTS', res.items);
        commit('SET_WATCHLIST_DOCUMENTS_COUNT', res.total);
      } catch (err) {
        console.error(
          'Error on get watchlist documents: ',
          err.message ? err.message : err
        );
      } finally {       
        commit('SET_LOADING_STATE', false)
      }
    },
    async getWatchlistDocumentEvents({ commit }) {
      try {
        const events = await apiUser.getWatchlistDocumentEvents();

        commit('SET_WATCHLIST_DOCUMENT_EVENTS', events);
      } catch (err) {
        console.error(
          'Error on get watchlist documents events: ',
          err.message ? err.message : err
        );
      }
    },
    async countUnreadWatchlistDocuments({ state, dispatch, commit }) {
      try {
        const newCount = await apiUser.countUnreadWatchlistDocuments();

        commit('SET_UNREAD_WATCHLIST_DOCUMENTS_COUNT', newCount);
      } catch (err) {
        console.error(
          'Error on get unread watchlist documents count: ',
          err.message ? err.message : err
        );
      }
    },

    // obj: {id: <string>, state: <boolean>}
    async toggleWatchedDocumentAsRead({ commit }, obj) {
      try {
        await apiUser.setWatchedDocumentAsRead(obj.id, obj.state);
      } catch (err) {
        console.error(
          'Error on toggle watched document as read: ',
          err.message ? err.message : err
        );
      }
    },

    // obj: {id: <string>, state: <boolean>}
    async setDocumentIsWatched({ commit }, obj) {
      try {
        await apiUser.setDocumentIsWatched(obj.id, obj.state);
      } catch (err) {
        console.error(
          'Error on set document unwatched: ',
          err.message ? err.message : err
        );
      }
    }
  }
};
